import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    NavigationMenuPanelDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getSurfaceStyle
} from "../../../../helpers/theme/elevation";

const stylesheet = StyleSheet.create({
    panel: {
        flexDirection: "column",
        position: "absolute",
        left: 0,
        top: 0
    },
    hidden: {
        pointerEvents: "none"
    },
    edges: {
        borderStartWidth: 0,
        borderEndWidth: 0,
        borderTopWidth: 0,
        borderRadius: 0
    }
});

export const useStyles = ({
    shadowAlpha,
    elevations,
    borders,
    colors,
    isShow,
    spaces,
    width
}: NavigationMenuPanelDynamicStyleType) => {
    const styles = {
        panel: {
            ...getSurfaceStyle({
                surface: "popover",
                shadowAlpha,
                elevations,
                borders,
                colors
            }),
            paddingHorizontal: spaces.spacingLg - spaces.spacingSm,
            paddingVertical: spaces.spacingLg,
            width
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.panel, stylesheet.edges);

    if(!isShow) {
        Object.assign(styles.panel, stylesheet.hidden);
    }

    return styles;
};
export default stylesheet;
